import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function KpiCard({
  label, value, sublabel, icon: Icon, accent = "slate", testId,
}) {
  const accents = {
    slate: "text-slate-900",
    sky: "text-sky-700",
    emerald: "text-emerald-700",
    amber: "text-amber-700",
    rose: "text-rose-700",
  };
  return (
    <Card
      className={cn(
        "bg-white border border-slate-200 rounded-lg p-5 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)] flex flex-col gap-2"
      )}
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <p className="text-xs tracking-[0.2em] uppercase font-semibold text-slate-500">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-slate-400" />}
      </div>
      <p className={cn("text-3xl font-semibold tracking-tight", accents[accent])} data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </p>
      {sublabel && <p className="text-xs text-slate-500">{sublabel}</p>}
    </Card>
  );
}
